/* eslint-disable react/no-array-index-key */
import { FieldArray, useFormikContext } from "formik";

import __ from "web/Layout/Translations";
import RentableGroupCalculatorAddPerson from "../RentableGroupCalculatorAddPerson";
import RentableGroupCalculatorHtmlContent from "../RentableGroupCalculatorHtmlContent";
import RentableGroupCalculatorPerson from "../RentableGroupCalculatorPerson";
import { RentableGroupCalculatorCopy } from "../const/rentableGroupCalculatorCopy";
import { IRentableGroupCalculatorValues } from "../rentableGroupCalculatorContainer";
import getNewPersonField from "../utils/getNewPersonField";
import classes from "./rentableGroupCalculator.scss";

const RentableGroupCalculator = ({ calculatorCopy }: { calculatorCopy: RentableGroupCalculatorCopy }) => {
  const { values } = useFormikContext<IRentableGroupCalculatorValues>();

  return (
    <section className={`${classes.root} rg-calculator`}>
      <RentableGroupCalculatorHtmlContent
        as="h3"
        className={classes.header}
        html={calculatorCopy?.calculatorHeader}
      />

      <div className={classes.innerWrapper}>
        {/* me */}
        <div>
          <RentableGroupCalculatorPerson
            personRole="me"
            selectName="me"
            inputName="income.me"
            calculatorCopy={calculatorCopy}
            isSelectDisabled
          />
        </div>

        {/* people */}
        <FieldArray name="income.people">
          {({ push, remove }) => (
            <>
              {(
                values as {
                  income: { people: { role: string; income: number }[] };
                }
              ).income.people?.map((person, index) => (
                <RentableGroupCalculatorPerson
                  key={person.role + index}
                  personRole={person.role}
                  calculatorCopy={calculatorCopy}
                  onRemove={() => remove(index)}
                  selectName={`income.people[${index}].role`}
                  inputName={`income.people[${index}].income`}
                />
              ))}

              {/* add person */}
              <div className={classes.addPersonBtnContainer}>
                <RentableGroupCalculatorAddPerson
                  addPersonCopy={__(calculatorCopy?.addPerson)}
                  onClick={() =>
                    push(getNewPersonField(values.income.people.length))
                  }
                />
              </div>
            </>
          )}
        </FieldArray>
      </div>
    </section>
  );
};
export default RentableGroupCalculator;
